/*
 * @Author: Latte
 * @Date: 2022-01-25 14:34:02
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-25 15:24:53
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\cloudService\staff.js
 */
import request from "@/utils/request";
import config from "@/utils/config";

/**
 * 客服模块获取工程师列表
 * @param {*} params
 * @returns
 */
export function getStaffList(params) {
	const arr = [];
	Object.entries(params).forEach((item) => {
		if (item[0] === "sortName") {
			item[1] = JSON.stringify(item[1]);
		}

		arr.push(`${item[0]}=${encodeURIComponent(item[1])}`);
	});
	return request({
		url: `${config.API_MEDICAL}/Api/V1/Engineers/List?${arr.join("&")}`,
		method: "get",
	});
}

/**
 * 添加工程师
 * @param {*} data
 * @returns
 */
export function addStaff(data) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/Engineers/Add",
		method: "post",
		data,
	});
}

/**
 * @description: 更新工程师信息
 * @param {*} data
 * @return {*}
 */
export function updateStaff(data) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/Engineers/Update",
		method: "post",
		data,
	});
}

/**
 * @description: 删除工程师
 * @param {*} params
 * @return {*}
 */
export function deleteStaff(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/Engineers/Delete",
		method: "delete",
		params,
	});
}
